var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.213,
    height: 33.213,
    viewBox: "0 0 33.213 33.213",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checked",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3083",
    "data-name": "Ellipse 3083",
    cx: 16.607,
    cy: 16.607,
    r: 16.607,
    transform: "translate(0 0)",
    fill: "#32ba7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38768",
    "data-name": "Path 38768",
    d: "M188.8,166.144l8.539,8.539a16.6,16.6,0,0,0,12.311-16.03v-.471L202.944,152Z",
    transform: "translate(-176.437 -142.047)",
    fill: "#0aa06e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16691",
    "data-name": "Group 16691",
    transform: "translate(5.579 8.199)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38769",
    "data-name": "Path 38769",
    d: "M96.646,206.856a1.961,1.961,0,0,1,0,2.724L95.127,211.1a1.961,1.961,0,0,1-2.724,0l-6.653-6.706a1.961,1.961,0,0,1,0-2.724l1.519-1.519a1.961,1.961,0,0,1,2.724,0Z",
    transform: "translate(-85.2 -194.728)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38770",
    "data-name": "Path 38770",
    d: "M176.475,125.75a1.961,1.961,0,0,1,2.724,0l1.519,1.519a1.961,1.961,0,0,1,0,2.724l-11.525,11.473a1.961,1.961,0,0,1-2.724,0l-1.519-1.519a1.961,1.961,0,0,1,0-2.724Z",
    transform: "translate(-159.214 -125.2)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/Checked.e859870b2e0909b91690de6807776b86.svg";
export { ForwardRef as ReactComponent };